import React from 'react'
import DefaultNavbar from 'examples/Navbars/DefaultNavbar'
import { rottePreLogin } from 'getter/getRotte'
import brand from 'assets/logoEtiqua/ORIZZONTALE NEGATIVO.svg'

export default function elementoNavigazionePreLogin(props) {
    if(props.transparent) return null
    return <DefaultNavbar brand={brand} backgroundColor={props.transparent ? 'transparent' : 'dark'} transparent relative light center routes={rottePreLogin} />
}
